import { Link } from "react-router-dom";
import { Empty, TopBar } from "@/ui/primitives";

/* A tela de "não cabe mais um".

   Existe como componente porque três portas levam ao mesmo lugar: criar,
   entrar com código, e o LINK DE CONVITE — que é a que mais importa. Quem
   recebe um convite e bate no muro precisa entender que o problema não é
   o convite nem o amigo que mandou. */

export function SemVaga(
  { ativos, limite, voltar = "/" }:
  { ativos: number; limite: number; voltar?: string },
) {
  return (
    <main className="screen">
      <TopBar back={voltar} />
      <Empty emoji="🍽️" title="Sem vaga por enquanto">
        <p>
          Você já está em {ativos} {ativos === 1 ? "desafio" : "desafios"} ao
          mesmo tempo, e o plano grátis vai até {limite}.
        </p>
        <p>
          Assim que um deles terminar a vaga volta sozinha — o limite conta
          desafios que ainda estão rolando, não os que você já fez.
        </p>
      </Empty>
      <div className="pad">
        <Link className="btn btn-primary" to="/assinar">Assinar e entrar em quantos quiser</Link>
        <Link className="btn btn-outline" to="/">Ver meus desafios</Link>
      </div>
    </main>
  );
}
